import { RemoteGetAllSemestersUser } from 'data/usecases/semesters';
import { GetAllSemestersUserUseCaseInterface } from 'domain/usecases';
import { makeApiUrlSemestersUser } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetAllSemestersUser =
  (): GetAllSemestersUserUseCaseInterface =>
    new RemoteGetAllSemestersUser(
      makeApiUrlSemestersUser(),
      makeAxiosHttpClient(),
    );
